<template lang="html">
  <div class="admin-images-wrapper">
    <div class="title">
      Reklamne slike
    </div>
    <table>
      <thead>
        <tr>
          <td>slika</td>
          <td style="width: 100px;"></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="banner in banners" :key="banner.img_id">
          <td>
            <img
              class="table-image"
              :src="imageLink(banner.image)"
              alt="image"
            />
          </td>
          <td>
            <div @click="openConfirmationModal(banner)" class="btn">
              obriši
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="action-wrapper">
      <div @click="openNewModal()" class="btn">
        Dodaj novu sliku
      </div>
    </div>
  </div>
</template>

<script>
import { api, baseURL } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'adminImages',
  data () {
    return {
      banners: []
    }
  },
  mounted () {
    this.getBanners()
  },
  methods: {
    getBanners () {
      api
        .getBanners()
        .then(res => {
          this.banners = res.data.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    openConfirmationModal (image) {
      let modalData = {
        title: 'Jeste li sigurni da želite da obrišete ovu sliku',
        ok: () => {
          this.deleteImage(image)
        }
      }
      let params = {
        modalData: modalData,
        component: 'confirmModal'
      }
      eventBus.$emit('openModal', params)
    },
    deleteImage (image) {
      api
        .deleteBanner(image.img_id)
        .then(res => {
          this.getBanners()
          this.$toast.success('Uspešno', {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error('Greška', {
            duration: 8000
          })
        })
    },
    openNewModal () {
      let modalData = {
        title: 'Dodaj novu reklamnu sliku',
        ok: image => {
          this.addImage(image)
        }
      }
      let params = {
        modalData: modalData,
        component: 'addImage'
      }
      eventBus.$emit('openModal', params)
    },
    addImage (image) {
      let params = new FormData()
      params.append('image', image.file)
      api
        .setBanner(params)
        .then(res => {
          this.getBanners()
          this.$toast.success('Uspešno', {
            duration: 8000
          })
        })
        .catch(e => {
          console.log(e)
          this.$toast.error('Greška', {
            duration: 8000
          })
        })
    },
    imageLink (image) {
      return baseURL + image
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-images-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';
  @import '@/assets/scss/tableStyles.scss';

  .title {
    margin-bottom: 25px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
  }
  .table-image {
    max-height: 100%;
  }
  table {
    margin-bottom: 20px;
  }
  .action-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
}
</style>
